<template>
  <div>
    <div class="content">
      <span class="subtitle has-text-weight-bold has-text-info">
        Roles
      </span>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Create Roles
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="create"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Edit Roles
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="edit"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Delete Roles
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="remove"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'PermissionsRolesform',

  computed: {
    create: {
      get() {
        return this.$store.state.Permissions.permissions.admin.roles.create;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_ROlES_CREATE', value);
      },
    },

    edit: {
      get() {
        return this.$store.state.Permissions.permissions.admin.roles.edit;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_ROlES_EDIT', value);
      },
    },

    remove: {
      get() {
        return this.$store.state.Permissions.permissions.admin.roles.delete;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ADMIN_ROlES_DELETE', value);
      },
    },
  },

};
</script>

<style lang="css" scoped>
</style>
